import React from 'react';
import { Button } from './components/ui/button';
import { CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { baseFolder } from './lib/constants';

function NotFound() {
  return (
    <section className="bg-white dark:bg-gray-900 ">
      <div className="container flex items-center mt-10 px-6 py-12 mx-auto">
        <div className="flex flex-col justify-center items-center max-w-lg mx-auto text-center">
          <p className="p-3 text-sm font-medium text-nku-yellow bg-[#ffd52c]/20 rounded-full dark:bg-gray-800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </p>
          <CardHeader className="pt-0 mt-0">
            <CardTitle className="text-3xl">Page not found</CardTitle>
            <CardDescription className="text-xl">
              The page you are looking for doesn't exist. Here are some helpful
              links:
            </CardDescription>
            <div className="flex items-center justify-center mt-6 gap-x-3 shrink-0 sm:w-auto">
              <Button
                onClick={() => {
                  window.history.back();
                }}
                variant="outline"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="w-5 h-5 rtl:rotate-180"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                  />
                </svg>

                <span className="ms-2">Go back</span>
              </Button>

              <a href={baseFolder}>
                <Button className="bg-nku-dark hover:bg-nku-dark/95">
                  Take me home
                </Button>
              </a>
            </div>
          </CardHeader>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
